import { DELETE, GET, PATCH, POST } from "../axios/apiService";

export const getCallsList = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/telephony/recordings${query ? `?${query}` : ""}`;
  // const url = `https://public-api.primerole.com/telephony/calls${query ? `?${query}` : ""}`;
  // const url = `https://stage-api.primerole.com/telephony/calls${query ? `?${query}` : ""}`;
  // console.log("API URL:", process.env.REACT_APP_API_BASE_URL_TELEPHONY);
  return GET(url, options);
};

export const getCallMetadata = async ({ callId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/telephony/recordings/${callId}`;
  return GET(url, options);
};

export const getCallDetails = async ({ callId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/sonic/api/v1/analysis/recording/${callId}`;
  return GET(url, options);
};